import { gql } from '@apollo/client'

export const TEST_SESSION_DETAIL = gql`
  query TestSessionWithoutMembersWithResult(
    $id: ID!
    $groupsInputData: TestSessionGroupsInput
    $companyInputData: TestSessionCompanyInput
    $skipResult: Boolean!
  ) {
    testSession(id: $id) {
      id
      name
      type
      category
      date
      endsAt
      isScheduled
      finishedAt
      rejectedAt
      Invoice {
        invoiceId
        invoiceDocNumber
        invoiceDate
        autoInvoice
      }
      sublocation
      staffs {
        id
        User {
          id
          firstName
          lastName
        }
      }
      RequestedByUser {
        id
        firstName
        lastName
      }
      Location {
        id
        street
        city
        zip
        country
        county
        complement
        state
        lat
        lon
      }
      Group {
        id
        name
        japaneseGroup
      }
      Groups(inputData: $groupsInputData) {
        id
        name
        japaneseGroup
      }
      Company(inputData: $companyInputData) {
        id
        name
      }
      Tests {
        id
        createdAt
        updatedAt
        barcode
        testedAt
        resultVerified
        resultVerifiedAt
        resultManuallyEntered
        result @skip(if: $skipResult)
        secondResult @skip(if: $skipResult)
        resultReceivedAt
        resultProvisionedAt
        specimenType
        Members {
          User {
            id
            firstName
            lastName
          }
          Group {
            id
            name
          }
          isParticipant
          isStaff
        }
        TestSession {
          lab
        }
      }

      Products {
        price
        quantity
        totalPrice
        Product {
          name
        }
      }
      PretestSessionSurveys {
        id
        User {
          id
          firstName
          lastName
        }
        PretestSessionSurveyResponses {
          id
          key
          value
        }
      }
      paymentStatus
      lab
      estimatedMembers
      Products {
        price
        quantity
        totalPrice
        Product {
          name
        }
      }
      totalPrice
      endsAt
      paymentError
      TestValues {
        specimenType
        rapidLotNumber
        rapidCartridgeExpirationDate
        rapidDockId
        rapidSpecimenNumber
        rapidExpirationDate
      }
    }
  }
`
